import React from "react";
import { motion } from "framer-motion";

// Import background images
import pinnacleImg from '../assets/media/pinnacle.jpg';
import piano1Img from '../assets/media/piano1.jpg';
import piano2Img from '../assets/media/piano2.jpg';
import codyImg from '../assets/media/cody.jpg';
import flowerspikesImg from '../assets/media/flowerspikes.jpg';
import codySmugImg from '../assets/media/cody-smug.jpg';

// Image mapping object
const backgroundImages: { [key: string]: string } = {
  'pinnacle': pinnacleImg,
  'piano1': piano1Img,
  'piano2': piano2Img,
  'cody': codyImg,
  'flowerspikes': flowerspikesImg,
  'cody-smug': codySmugImg,
};

interface HeroProps {
  data?: {
    title?: string;
    description?: string;
    background?: string;
  };
}

const Hero: React.FC<HeroProps> = ({ data }) => {
  // Debug logs
  console.log('Hero data:', data);
  console.log('Available background images:', backgroundImages);
  
  // Ensure data is an object and provide default values
  const title = data?.title || "Cody"
  const newLocal = data?.description || "Howdy! 👋";
  const description = newLocal;
  const backgroundImage = data?.background ? backgroundImages[data.background] : '';
  
  console.log('Selected background key:', data?.background);
  console.log('Background image URL:', backgroundImage);
  console.log('Full style object:', {
    backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'none',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  });

  // Check if this is the Welcome page (no title provided)
  const isWelcomePage = !data?.title;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.6, ease: "easeInOut" }}
      className={`relative ${isWelcomePage ? 'min-h-screen' : 'min-h-[60vh]'} flex items-center justify-center text-center px-4`}
      style={{
        backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'none',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      {/* Overlay with fade-in animation */}
      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.3 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5, delay: 0.1 }}
        className="absolute inset-0 bg-black"
      />

      {/* Content */}
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        transition={{ 
          duration: 0.5,
          ease: [0.6, -0.05, 0.01, 0.99]
        }}
        className="relative z-10 max-w-4xl mx-auto"
      >
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ 
            duration: 0.5, 
            delay: 0.1,
            ease: [0.6, -0.05, 0.01, 0.99]
          }}
          className="text-4xl md:text-6xl font-bold text-white mb-4"
        >
          {title}
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ 
            duration: 0.5, 
            delay: 0.2,
            ease: [0.6, -0.05, 0.01, 0.99]
          }}
          className="text-xl text-gray-300 mb-4"
        >
          {description}
        </motion.p>
      </motion.div>
    </motion.div>
  );
};

export default Hero; 